import { isMobile } from "react-device-detect";

export const renderSignature = (canvasElement, targetSize = 225) => {
	if (!canvasElement) return null;

	const ctx 				= canvasElement.getContext('2d');
	const { width, height } = canvasElement;
	const imgData 			= ctx.getImageData(0, 0, width, height);
	const data 				= imgData.data;

	// 1. Manual Trim Logic
	let top = height, left = width, bottom = 0, right = 0;
	for (let y = 0; y < height; y++) {
		for (let x = 0; x < width; x++) {
			if (data[(y * width + x) * 4 + 3] > 0) {
				if (x < left) left = x; if (x > right) right = x;
				if (y < top) top = y; if (y > bottom) bottom = y;
			}
		}
	}

	// Check if empty
	if (bottom <= top) return null;

	// 2. Create the output canvas
	const outputCanvas 	= document.createElement('canvas');
	outputCanvas.width 	= targetSize;
	outputCanvas.height = targetSize;
	const outCtx 		= outputCanvas.getContext('2d');

	// 4. Scale to 300x300 (or 200x200) while keeping ratio
	const trimW 		= right - left;
	const trimH 		= bottom - top;
	const padding 		= 20;
	const ratio 		= Math.min((targetSize - padding) / trimW, (targetSize - padding) / trimH);

	const drawW 		= trimW * ratio;
	const drawH 		= trimH * ratio;
	const offsetX 		= (targetSize - drawW) / 2;
	const offsetY 		= (targetSize - drawH) / 2;

	outCtx.drawImage(canvasElement, 
		left, top, 
		trimW, trimH, 
		offsetX, offsetY, 
		drawW, drawH
	);

	// 5. Export
	return outputCanvas.toDataURL('image/png');
}